export default __webpack_public_path__ + "static/media/pattern_hexagon-min.f33e30d3.png";